import { normalizeSession, storageKey } from './robotRoundContract';

function getStorage(storage) {
  if (storage) return storage;
  if (typeof window === 'undefined') return null;
  return window.localStorage;
}

export function readRobotRoundSession(uid, storage) {
  const target = getStorage(storage);
  if (!target) return null;
  try {
    return normalizeSession(JSON.parse(target.getItem(storageKey(uid)) || 'null'));
  } catch {
    return null;
  }
}

export function writeRobotRoundSession(session, uid = session?.ownerUid, storage) {
  const target = getStorage(storage);
  if (!target || !session) return false;
  try {
    target.setItem(storageKey(uid), JSON.stringify(session));
    return true;
  } catch {
    return false;
  }
}

export function clearRobotRoundSession(uid, storage) {
  const target = getStorage(storage);
  if (!target) return false;
  try {
    target.removeItem(storageKey(uid));
    return true;
  } catch {
    return false;
  }
}
